// V1 节点语义固定；新排版能力须升级 schemaVersion 并补两端一致性样例。
export const displayWidth = text => Array.from(String(text)).reduce((sum, char) => sum + (char.codePointAt(0) > 127 ? 2 : 1), 0);

export function wrapText(value, columns) {
  const result = [];
  for (const paragraph of String(value ?? '').replace(/\r/g, '').split('\n')) {
    let line = '';
    for (const char of Array.from(paragraph).filter(char => char.codePointAt(0) >= 32 && char.codePointAt(0) !== 127)) {
      if (displayWidth(line + char) > columns && line) { result.push(line); line = ''; }
      line += char;
    }
    result.push(line);
  }
  return result;
}

const get = (data, field) => field.split('.').reduce((value, key) => value?.[key], data);
const bind = (text, data) => String(text ?? '').replace(/\{\{([\w.]+)\}\}/g, (_, field) => String(get(data, field) ?? ''));
const pad = (text, width, align) => {
  const gap = Math.max(0, width - displayWidth(text));
  const left = align === 'right' ? gap : align === 'center' ? Math.floor(gap / 2) : 0;
  return ' '.repeat(left) + text + ' '.repeat(gap - left);
};

export function resolveTemplate(catalog, formats, kind) {
  if (formats != null && formats.schemaVersion !== 1) throw new Error('票据样式版本不受支持，请升级客户端');
  const selection = formats?.selections?.[kind] ?? catalog.defaults[kind];
  const template = catalog.templates.find(item => item.kind === kind && item.id === selection?.templateId && item.templateVersion === selection?.templateVersion);
  if (!template || template.schemaVersion !== 1) throw new Error('票据模板版本不受支持，请升级客户端');
  return template;
}

export function renderTemplate(template, data) {
  if (template.schemaVersion !== 1) throw new Error('票据样式版本不受支持，请升级客户端');
  const lines = [];
  const visit = (nodes, scope) => {
    for (const node of nodes) {
      if (node.when && !String(get(scope, node.when) ?? '').trim()) continue;
      if (node.type === 'repeat') {
        const items = get(scope, node.field);
        if (Array.isArray(items)) items.forEach(item => visit(node.nodes, { ...scope, item }));
        continue;
      }
      const style = { align: node.align || 'left', bold: Boolean(node.bold), widthScale: node.widthScale || 1, heightScale: node.heightScale || 1, lineSpacing: template.lineSpacing };
      const width = Math.floor(template.paper.columns / style.widthScale);
      let texts;
      if (node.type === 'text') texts = wrapText(bind(node.text, scope), width);
      else if (node.type === 'separator') texts = [String(node.char || '-').repeat(width)];
      else if (node.type === 'space') texts = Array.from({ length: node.count || 1 }, () => '');
      else if (node.type === 'row') {
        const sum = node.cells.reduce((n, cell) => n + cell.width, 0);
        let remaining = width;
        const cells = node.cells.map((cell, index) => {
          const columns = index === node.cells.length - 1 ? remaining : Math.floor(width * cell.width / sum);
          remaining -= columns;
          return { ...cell, columns, texts: wrapText(bind(cell.text, scope), columns) };
        });
        texts = Array.from({ length: Math.max(...cells.map(cell => cell.texts.length)) }, (_, i) => cells.map(cell => pad(cell.texts[i] || '', cell.columns, cell.align)).join(''));
      } else throw new Error(`未知票据节点：${node.type}`);
      lines.push(...texts.map(text => ({ type: 'text', text, ...style })));
    }
  };
  visit(template.nodes, data);
  return { documentVersion: 2, kind: template.kind, format: { schemaVersion: 1, templateId: template.id, templateVersion: template.templateVersion, ...template.paper }, lines };
}
